import React, { useState, useEffect } from "react";
import { LeadViewProps } from "./lead-view.props";
import {
  BreadcrumbComponent,
  CustomTabPanelComponent,
} from "../../../common/components";
import LeadViewDetailsViewPrimaryInfo from "./lead-view-details/lead-view-details-view/lead-view-details-view-primary-info/lead-view-details-view-primary-info";
import "./lead-view.scss";
import { getLeadDetails } from "../../../api/lead";
import LeadViewDetailsAllTabs from "./lead-view-details-all-tabs";
import { AlertComponent } from "../../../common/components";
import LeadViewEditViewPrimaryInfo from "./lead-view-details/lead-view-details-edit/lead-view-edit-view-primary-info/lead-view-edit-view-primary-info";
import { useResourcePermissions } from "../../../common/hooks/resource-permissions";
import MODULES from "../../../constants/modules";
import ViewMeeting from "./lead-view-details/lead-view-details-view/lead-view-details-view-open-activities-info/view-meeting/view-meeting";
import ViewTask from "./lead-view-details/lead-view-details-view/lead-view-details-view-open-activities-info/view-task/view-task";
import CallView from "./lead-view-details/lead-view-details-view/lead-view-details-view-open-activities-info/view-call/view-call";
import LeadViewDetailsAllTabsResponsive from "./lead-view-all-tabs-responsive";
import { useMediaQuery } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import { Box } from "@mui/material";
import { breadcrumbLink } from "../lead-list.constant";
import { routes } from "../../../constants/routes";

const LeadView: React.FC<LeadViewProps> = (props: any) => {
  const {
    disableLeadStatus,
    // setViewTaskvalue = () => {},
    // viewTaskvalue = {},
    setCrumbMappingOption = () => {},
    // setViewMeetingvalue = () => {},
    // viewMeetingvalue = {},
    // setViewCallValue = () => {},
    // viewCallValue,
  } = props;
  const { canWrite, canDelete, canRead } = useResourcePermissions(
    MODULES.LEAD_DETAILS,
  );
  const isMobile = useMediaQuery("(max-width:768px)");
  const [viewOpen, setViewOpen] = useState<boolean>(false);
  const [viewEditOpen, setViewEditOpen] = useState<boolean>(false);
  const [leadDetails, setLeadDetails] = useState<any>(null);
  const [alertOpen, setAlertOpen] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [alertType, setAlertType] = useState<"success" | "error">("success");
  const [viewPrimaryInfoOpen, setViewPrimaryInfoOpen] =
    useState<boolean>(false);
  const [uploadedImage, setUploadedImage] = useState("");
  const [uploadedImageFile, setUploadedImageFile] = useState<File | null>(null);
  const [viewFullInfoOpen, setViewFullInfoOpen] = useState<boolean>(false);
  const [uploadError, setUploadError] = useState<string | null>(null);
  const [viewAddFullInfoOpen, setViewAddFullInfoOpen] =
    useState<boolean>(false);
  const [removeImage, setRemoveImage] = useState(false);
  // Use setLoading from props if provided, otherwise define a local one
  const [internalLoading, internalSetLoading] = useState(false);
  const setLoading = props.setLoading || internalSetLoading;
  const loading =
    typeof props.loading !== "undefined" ? props.loading : internalLoading;
  const [breadcrumbMapping, setBreadcrumbMapping] =
    useState<any>(breadcrumbLink);
  const navigate = useNavigate();
  const location = useLocation();
  // Task
  const [internalViewTask, setInternalViewTask] = useState<{
    open: boolean;
    taskId: number | null;
  }>({
    open: false,
    taskId: null,
  });
  const viewTaskvalue = props.viewTaskvalue || internalViewTask;
  const setViewTaskvalue = props.setViewTaskvalue || setInternalViewTask;

  // Meeting
  const [internalViewMeeting, setInternalViewMeeting] = useState<{
    open: boolean;
    meetingId: number | null;
  }>({
    open: false,
    meetingId: null,
  });
  const viewMeetingvalue = props.viewMeetingvalue || internalViewMeeting;
  const setViewMeetingvalue =
    props.setViewMeetingvalue || setInternalViewMeeting;

  // Call
  const [internalViewCall, setInternalViewCall] = useState<{
    open: boolean;
    callId: number | null;
  }>({
    open: false,
    callId: null,
  });
  const viewCallValue = props.viewCallValue || internalViewCall;
  const setViewCallValue = props.setViewCallValue || setInternalViewCall;

  const {
    breadCrumb,
    selectedLeadId: selectedLeadIdFromState,
    leadName,
  } = location.state || {};
  // Use either prop or route param
  const selectedLeadId = props.selectedLeadId || selectedLeadIdFromState;

  const resetImageUpload = () => {
    setUploadedImage(leadDetails?.lead_profile_file_Url || "");
    setUploadedImageFile(null);
    setRemoveImage(false);
  };
  const fetchLeadDetails = async () => {
    setLoading(true);
    try {
      const response = await getLeadDetails(selectedLeadId);
      setLeadDetails(response.data.data);
      setTimeout(() => setLoading(false), 1000);
    } catch (error: any) {
      setLoading(false);
      setAlertMessage(
        error?.response?.data?.message ||
          "An error occurred while saving the lead.",
      );
      setAlertType("error");
      setAlertOpen(true);
    }
  };

  useEffect(() => {
    fetchLeadDetails();
  }, [selectedLeadId]);

  const handleEditOpen = () => {
    setViewEditOpen(true);
  };

  const handleAlertClose = () => {
    setAlertOpen(false);
  };
  useEffect(() => {
    if (breadCrumb) {
      const customMapping = [
        {
          label: "Lead Management",
          link: routes.LEADLIST,
          handleClick: (event: any) => {
            event.preventDefault();
            setViewTaskvalue({ open: false, taskId: null });
            setViewMeetingvalue({ open: false, meetingId: null });
            setViewCallValue({ open: false, callId: null });
            setCrumbMappingOption(breadcrumbLink);
            setViewOpen(false);
            navigate(routes.LEADLIST);
          },
        },
        {
          label: "Leads",
          link: routes.LEADLIST,
          handleClick: (event: any) => {
            event.preventDefault();
            setViewTaskvalue({ open: false, taskId: null });
            setViewMeetingvalue({ open: false, meetingId: null });
            setViewCallValue({ open: false, callId: null });
            setCrumbMappingOption(breadcrumbLink);
            setViewOpen(false);
            navigate(routes.LEADLIST);
          },
        },
        { label: leadName, link: "" },
      ];
      setBreadcrumbMapping(customMapping);
      setCrumbMappingOption();
    }
  }, [breadCrumb, leadName]);
  return (
    <>
      {breadCrumb && (
        <Box className="breadcrumb-wrapper">
          <BreadcrumbComponent
            breadcrumbLink={breadcrumbMapping}
            showBackArrow
            handleBackArrowClick={() => navigate(routes.LEADLIST)}
          />
        </Box>
      )}
      <div className="lead-list-view">
        <div
          style={{
            display:
              !viewTaskvalue?.open &&
              !viewMeetingvalue?.open &&
              !viewCallValue?.open
                ? "block"
                : "none",
          }}
        >
          {isMobile ? (
            <div style={{ paddingTop: "20px", paddingBottom: "20px" }}>
              <LeadViewDetailsViewPrimaryInfo
                leadDetails={leadDetails}
                viewPrimaryInfoOpen={viewPrimaryInfoOpen}
                setViewPrimaryInfoOpen={setViewPrimaryInfoOpen}
                viewFullInfoOpen={viewFullInfoOpen}
                uploadedImage={uploadedImage}
                setUploadedImage={setUploadedImage}
                setUploadedImageFile={setUploadedImageFile}
                setRemoveImage={setRemoveImage}
                isMobile={isMobile}
                setUploadError={setUploadError}
                uploadError={uploadError}
              />
            </div>
          ) : (
            <CustomTabPanelComponent value={0} index={0}>
              {viewPrimaryInfoOpen ? (
                <LeadViewEditViewPrimaryInfo
                  setViewPrimaryInfoOpen={setViewPrimaryInfoOpen}
                  viewPrimaryInfoOpen={viewPrimaryInfoOpen}
                />
              ) : (
                <LeadViewDetailsViewPrimaryInfo
                  leadDetails={leadDetails}
                  viewPrimaryInfoOpen={viewPrimaryInfoOpen}
                  setViewPrimaryInfoOpen={setViewPrimaryInfoOpen}
                  viewFullInfoOpen={viewFullInfoOpen}
                  uploadedImage={uploadedImage}
                  setUploadedImage={setUploadedImage}
                  setUploadedImageFile={setUploadedImageFile}
                  setRemoveImage={setRemoveImage}
                  setUploadError={setUploadError}
                  uploadError={uploadError}
                  setAlertMessage={setAlertMessage}
                  setAlertType={setAlertType}
                  setAlertOpen={setAlertOpen}
                />
              )}
            </CustomTabPanelComponent>
          )}
          {isMobile ? (
            <LeadViewDetailsAllTabsResponsive
              leadDetails={leadDetails}
              selectedLeadId={selectedLeadId}
              setLoading={setLoading}
              viewFullInfoOpen={viewFullInfoOpen}
              setViewFullInfoOpen={setViewFullInfoOpen}
              viewAddFullInfoOpen={viewAddFullInfoOpen}
              setViewAddFullInfoOpen={setViewAddFullInfoOpen}
              uploadedImage={uploadedImage}
              setUploadedImage={setUploadedImage}
              uploadedImageFile={uploadedImageFile}
              setUploadedImageFile={setUploadedImageFile}
              setRemoveImage={setRemoveImage}
              removeImage={removeImage}
              fetchLeadDetails={fetchLeadDetails}
              onLeadNameUpdate={props.onLeadNameUpdate}
              leadId={selectedLeadId}
              resetImageUpload={resetImageUpload}
              setAlertMessage={setAlertMessage}
              setAlertType={setAlertType}
              setAlertOpen={setAlertOpen}
              disableLeadStatus={disableLeadStatus}
              permissions={{ canWrite, canDelete, canRead }}
              setCrumbMappingOption={
                breadCrumb ? setBreadcrumbMapping : setCrumbMappingOption
              }
              setViewTaskvalue={setViewTaskvalue}
              setViewMeetingvalue={setViewMeetingvalue}
              setViewCallValue={setViewCallValue}
              isMobile={isMobile}
              setUploadError={setUploadError}
            />
          ) : (
            <LeadViewDetailsAllTabs
              leadDetails={leadDetails}
              selectedLeadId={selectedLeadId}
              setLoading={setLoading}
              viewFullInfoOpen={viewFullInfoOpen}
              setViewFullInfoOpen={setViewFullInfoOpen}
              viewAddFullInfoOpen={viewAddFullInfoOpen}
              setViewAddFullInfoOpen={setViewAddFullInfoOpen}
              uploadedImage={uploadedImage}
              setUploadedImage={setUploadedImage}
              uploadedImageFile={uploadedImageFile}
              setUploadedImageFile={setUploadedImageFile}
              setRemoveImage={setRemoveImage}
              removeImage={removeImage}
              fetchLeadDetails={fetchLeadDetails}
              onLeadNameUpdate={props.onLeadNameUpdate}
              leadId={selectedLeadId}
              resetImageUpload={resetImageUpload}
              setAlertMessage={setAlertMessage}
              setAlertType={setAlertType}
              setAlertOpen={setAlertOpen}
              disableLeadStatus={disableLeadStatus}
              permissions={{ canWrite, canDelete, canRead }}
              setCrumbMappingOption={
                breadCrumb ? setBreadcrumbMapping : setCrumbMappingOption
              }
              setViewTaskvalue={setViewTaskvalue}
              setViewMeetingvalue={setViewMeetingvalue}
              setViewCallValue={setViewCallValue}
              setUploadError={setUploadError}
            />
          )}
          <AlertComponent
            message={alertMessage}
            type={alertType}
            open={alertOpen}
            onClose={handleAlertClose}
          />
        </div>
        {!viewTaskvalue?.open ? (
          ""
        ) : (
          <ViewTask taskId={viewTaskvalue?.taskId} leadDetails={leadDetails} />
        )}
        {!viewMeetingvalue?.open ? (
          ""
        ) : (
          <ViewMeeting
            meetingId={viewMeetingvalue?.meetingId}
            leadDetails={leadDetails}
          />
        )}
        {!viewCallValue?.open ? (
          ""
        ) : (
          <CallView callId={viewCallValue?.callId} leadDetails={leadDetails} />
        )}
      </div>
    </>
  );
};

export default LeadView;
